import { FC } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import { GlobalIcon } from 'components/GlobalIcon';
import { CustomTooltip } from 'components/Tooltip';
import { Switch } from 'newcomponents/UI/Switch';
import { EventAction } from '../EventAction';
import './index.less';

type Props = {
  featureIsActive: boolean;
  setFeatureIsActive: (val: boolean) => void;
  tooltipText?: string;
  featureName: string;
  className?: string;
  skipRowStyles?: boolean;
};

export const BetslipFeatureSwitcher: FC<Props> = ({
  featureIsActive,
  setFeatureIsActive,
  tooltipText,
  featureName,
  className,
  skipRowStyles = false
}) => {
  return (
    <div
      data-testid={featureName.toLowerCase()}
      className={cc([
        'betslip-switcher__wrapper',
        className,
        {
          'betslip-switcher__wrapper__active': featureIsActive && !skipRowStyles
        }
      ])}
    >
      <div className="betslip__switcher__container">
        {tooltipText ? (
          <CustomTooltip
            arrowPointAtCenter={true}
            title={
              <span style={{ color: 'var(--v3-text-color)', fontSize: '12px' }}>
                {tooltipText}
              </span>
            }
            overlayClassName={
              isMobile() ? 'tooltipBetslipMob' : 'tooltipBetslip'
            }
            placement={isMobile() ? 'topLeft' : 'topRight'}
            trigger={['click', 'hover']}
            color="white"
            overlayStyle={{ color: 'red' }}
          >
            <EventAction
              className="betslip__feature-info"
              icon={
                <GlobalIcon
                  lib="generic"
                  name="info"
                  theme="default"
                  size={EIconSize._16}
                />
              }
              size="md"
            />
          </CustomTooltip>
        ) : null}

        {featureName}
      </div>
      <Switch checked={featureIsActive} onChange={setFeatureIsActive} />
    </div>
  );
};
